// Перечисление цветов
export enum Colors {
  BLACK = 'black',
  WHITE = 'white'
}
